import { CustodianModel } from "@verivest/shared-components/src/api/models";
import { validateAllAttributesExistInData } from "./validateAllAttributesExistInData";

export const validateCustodianReqAttr = (
  custodian: CustodianModel | null | undefined,
) => {
  if (!custodian) {
    return false;
  }

  const custodianReqAttr: Array<keyof CustodianModel> = ["name", "ein"];

  return validateAllAttributesExistInData(custodianReqAttr, custodian);
};
